import {
    GQLCustomPlanTrial,
    GQLPlanTrial,
} from '@upheal/graphql/definitions/schema.generated';
import { isFreePlan, isMeteredPlan, isStarterPlan } from './plans';

export const CUSTOM_TRIAL_PERIOD_DAYS = 30;

/**
 * User
 *  - can start custom trial if he is on free or starter and customTrial is not started yet
 *  - can't start custom trial if he is on premium or higher plan (or in trial)
 *  - can't start custom trial if he is on free or starter and customTrial is ongoing (days left > 0)
 */
export const canStartCustomTrial = (
    planId: string | undefined,
    customTrial: GQLCustomPlanTrial | null | undefined,
) => {
    const customTrialsCounter = customTrial?.counter ?? 0;
    const isUserOnFreeOrStartPlan = isFreePlan(planId) || isStarterPlan(planId);

    return (
        isUserOnFreeOrStartPlan && (!customTrial || customTrialsCounter === 0)
    );
};

export const isCustomTrial = (
    trial: GQLCustomPlanTrial | GQLPlanTrial,
): trial is GQLCustomPlanTrial => {
    return trial.__typename === 'CustomPlanTrial';
};

export const isTrialExpired = (
    trial: GQLPlanTrial | GQLCustomPlanTrial | null | undefined,
) => {
    return Boolean(trial && trial.daysLeft <= 0);
};

export const isActiveTrial = (
    trial: GQLPlanTrial | GQLCustomPlanTrial | null | undefined,
) => {
    return Boolean(trial && trial.daysLeft > 0);
};

type MeteredTrialExpiredParams = {
    planId: string | undefined;
    trial: GQLPlanTrial | null | undefined;
    hasPaymentMethod: boolean | null | undefined;
};

export const isMeteredTrialExpired = ({
    planId,
    trial,
    hasPaymentMethod,
}: MeteredTrialExpiredParams) => {
    return isMeteredPlan(planId) && !trial && hasPaymentMethod === false;
};
